import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import Modal from "react-bootstrap/Modal";
import getCroppedImg from "./cropImage.js";
import useFileUpload from "../../../../hooks/dataSenders/singleUpload.js";
import axios from "axios";
import { Api_Url } from "../../../../utils/ApiUrl.js";

const Team = ({
  teamFormData,
  setTeamFormData,
  teamFormErrors,
  setTeamFormErrors,
  setLoader,
}) => {
  const [show, setShow] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const { uploadFile } = useFileUpload();

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setImageSrc(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  };

  // Add new team member
  const addMember = () => {
    setTeamFormData((prev) => ({
      ...prev,
      team: [...prev.team, { image: null, name: "", designation: "", bio: "" }],
    }));

    setTeamFormErrors((prev) => ({
      ...prev,
      team: [...(prev.team || []), {}],
    }));
  };

  // Remove team member
  const removeMember = (index) => {
    setTeamFormData((prev) => ({
      ...prev,
      team: prev.team.filter((_, i) => i !== index),
    }));

    setTeamFormErrors((prev) => ({
      ...prev,
      team: (prev.team || []).filter((_, i) => i !== index),
    }));
  };

  // Handle input changes
  const handleChange = (index, field, value) => {
    const updatedTeam = [...teamFormData.team];
    updatedTeam[index][field] = field === "bio" ? value.slice(0, 300) : value;

    setTeamFormData((prev) => ({
      ...prev,
      team: updatedTeam,
    }));

    // Clear error for this field when user types
    if (teamFormErrors.team?.[index]?.[field]) {
      const updatedErrors = [...(teamFormErrors.team || [])];
      if (updatedErrors[index]) {
        updatedErrors[index] = {
          ...updatedErrors[index],
          [field]: "",
        };
      }
      setTeamFormErrors((prev) => ({
        ...prev,
        team: updatedErrors,
      }));
    }
  };

  // Handle image upload
  const handleImageUpload = (index, file) => {
    if (!file) return;
    const maxSize = 3 * 1024 * 1024; // 3MB in bytes
    if (file.size > maxSize) {
      // Set error for this specific team member's image
      const updatedErrors = [...(teamFormErrors.team || [])];
      if (!updatedErrors[index]) {
        updatedErrors[index] = {};
      }
      updatedErrors[index].image = "Image size must be less than 3MB";

      setTeamFormErrors((prev) => ({
        ...prev,
        team: updatedErrors,
      }));

      document.getElementById(`team-input-${index}`).value = "";
      return;
    }

    // Clear any previous image errors for this team member
    const updatedErrors = [...(teamFormErrors.team || [])];
    if (updatedErrors[index]) {
      updatedErrors[index] = {
        ...updatedErrors[index],
        image: "",
      };
    }

    setTeamFormErrors((prev) => ({
      ...prev,
      team: updatedErrors,
    }));

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setImageSrc(reader.result);
      setCurrentIndex(index);
      handleShow();
    };
  };

  // Delete image
  const handleDeleteImage = (index) => {
    const updatedTeam = [...teamFormData.team];
    const imageToDelete = updatedTeam[index].image;

    // Remove from state immediately for better UX
    updatedTeam[index].image = null;
    setTeamFormData((prev) => ({
      ...prev,
      team: updatedTeam,
    }));

    // Delete from server in background
    if (imageToDelete) {
      const token = localStorage.getItem("accessToken");

      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${Api_Url}/uploads/`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: JSON.stringify({
          url: [imageToDelete],
        }),
      };

      axios
        .request(config)
        .then((response) => {
          console.log("Image deleted from server:", response.data);
        })
        .catch((error) => {
          console.error("Error deleting image from server:", error);
          // Optionally show a non-blocking notification
        });
    }
  };

  // Crop callbacks
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const base64ToFile = (base64String, filename = "image.png") => {
    // Remove the data:image/png;base64, part
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  // Save cropped image
  const handleSaveCroppedImage = async () => {
    try {
      const cropped = await getCroppedImg(imageSrc, croppedAreaPixels);
      const croppedFile = base64ToFile(cropped, "cropped-image.png");
      const url = await uploadFile(croppedFile, setLoader);
      const updatedTeam = [...teamFormData.team];
      updatedTeam[currentIndex].image = url;

      setTeamFormData((prev) => ({
        ...prev,
        team: updatedTeam,
      }));
      setZoom(1);

      handleClose();
    } catch (error) {
      console.error("Error cropping image:", error);
      // alert("Failed to crop image");
    }
  };

  return (
    <>
      <div className="parentsteps">
        <section className="thirdstep">
          <div className="inner_sidenew">
            <h2>
              Team <span>(Optional)</span>
            </h2>

            {teamFormData.team.map((m, i) => (
              <div className="boxone" key={i}>
                <div className="boxes_top">
                  <div className="lowerboxxx">
                    <div className="downloddimg">
                      {m.image ? (
                        <img
                          src={m.image}
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "360px",
                            objectFit: "cover",
                            cursor: "pointer",
                          }}
                          alt="preview"
                          className="teamPreview"
                          onClick={() =>
                            document.getElementById(`team-input-${i}`).click()
                          }
                        />
                      ) : (
                        <img
                          src="/assets/downlodnew.svg"
                          onClick={() =>
                            document.getElementById(`team-input-${i}`).click()
                          }
                          style={{ cursor: "pointer" }}
                        />
                      )}
                    </div>

                    <div>
                      <h3 className="elip">
                        800×800 resolution • Max 3MB • JPEG/PNG
                      </h3>

                      {m.image ? (
                        <div style={{ display: "flex", gap: "8px" }}>
                          <button
                            className="replacccebutton"
                            onClick={() =>
                              document.getElementById(`team-input-${i}`).click()
                            }
                          >
                            Replace
                          </button>
                          <button
                            className="deletebuttton1"
                            onClick={() => handleDeleteImage(i)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                            >
                              <path
                                d="M2 4H14"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M12.6666 4V13.3333C12.6666 14 12 14.6667 11.3333 14.6667H4.66665C3.99998 14.6667 3.33331 14 3.33331 13.3333V4"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.33331 3.99967V2.66634C5.33331 1.99967 5.99998 1.33301 6.66665 1.33301H9.33331C9.99998 1.33301 10.6666 1.99967 10.6666 2.66634V3.99967"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M6.66669 7.33301V11.333"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9.33331 7.33301V11.333"
                                stroke="#FC4F52"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() =>
                            document.getElementById(`team-input-${i}`).click()
                          }
                        >
                          Upload Image
                        </button>
                      )}

                      <input
                        type="file"
                        id={`team-input-${i}`}
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          handleImageUpload(i, e.target.files[0]);
                          e.target.value = ""; // Reset the input so same file can be selected again
                        }}
                      />
                      {teamFormErrors.team?.[i]?.image && (
                        <span className="latesttexterror">
                          {teamFormErrors.team[i].image}
                        </span>
                      )}
                    </div>
                  </div>

                  <div>
                    <div className="innner_boxess">
                      <div>
                        <h4>Full Name</h4>
                        <input
                          type="text"
                          placeholder="Enter full name"
                          value={m.name}
                          onChange={(e) =>
                            handleChange(i, "name", e.target.value)
                          }
                          className={
                            teamFormErrors.team?.[i]?.name ? "error" : ""
                          }
                        />
                        {teamFormErrors.team?.[i]?.name && (
                          <span className="error-text">
                            {teamFormErrors.team[i].name}
                          </span>
                        )}
                      </div>

                      <div>
                        <h4>Designation</h4>
                        <input
                          type="text"
                          placeholder="Enter Designation"
                          value={m.designation}
                          onChange={(e) =>
                            handleChange(i, "designation", e.target.value)
                          }
                          className={
                            teamFormErrors.team?.[i]?.designation ? "error" : ""
                          }
                        />
                        {teamFormErrors.team?.[i]?.designation && (
                          <span className="error-text">
                            {teamFormErrors.team[i].designation}
                          </span>
                        )}
                      </div>
                    </div>

                    <div>
                      <h4 className="biotexttt">Bio</h4>
                      <textarea
                        placeholder="Team member bio"
                        value={m.bio}
                        onChange={(e) => handleChange(i, "bio", e.target.value)}
                        className={teamFormErrors.team?.[i]?.bio ? "error" : ""}
                      ></textarea>
                      <h5>{m.bio?.length || 0}/300 Characters</h5>
                      {teamFormErrors.team?.[i]?.bio && (
                        <span className="error-text">
                          {teamFormErrors.team[i].bio}
                        </span>
                      )}
                    </div>
                    {teamFormData.team?.length > 1 && (
                      <button
                        className="redbutton"
                        onClick={() => removeMember(i)}
                      >
                        Remove Team Member
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}

            <button className="addBtn" onClick={addMember}>
              Add another
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M5 10H15"
                  stroke="#02171D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10 15V5"
                  stroke="#02171D"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </section>
      </div>

      {/* IMAGE CROP MODAL */}
      <Modal
        className="publish-modall"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Crop Image</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="publish_modal">
            <div className="croopppy">
              <div className="cropmodal">
                {imageSrc && (
                  <div
                    className="crop-container inercrop"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "240px",
                      background: "#E7EEF2",
                      borderRadius: "4px",
                      overflow: "hidden",
                    }}
                  >
                    <Cropper
                      image={imageSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                )}
              </div>
              <p>Drag to reposition image</p>

              <div className="zoom-slider">
                <h5>Zoom</h5>
                <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={(e) => setZoom(Number(e.target.value))}
                  style={{
                    width: "100%",
                    height: "8px",
                    borderRadius: "10px",
                    appearance: "none",
                    outline: "none",
                  }}
                />
              </div>

              <div className="publish_buttons">
                <button className="cancel_button" onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="confirm_button"
                  onClick={handleSaveCroppedImage}
                >
                  Save Cropped Image
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Team;
